// extracted by mini-css-extract-plugin
export default {"baseContainer":"app_baseContainer__Mz8sj"};